import api from '.';
import downloadFile from '../functions/downloadFile';

interface QueryGetChecklistUserApprovalFiles {
  ids: number[];
  filename: string;
}

export async function getChecklistUserApprovalFiles({
  ids,
  filename
}: QueryGetChecklistUserApprovalFiles): Promise<void> {
  const { data } = await api.get(`checklist-user-approval-files/download`, {
    params: { ids },
    responseType: 'blob'
  });
  downloadFile({ data, contentType: data.type, filename });
}
